import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import "./Navigation.css";

const SimpleNavigation: React.FC = () => {
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleMouseEnter = (name: string) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setActiveDropdown(name);
  };

  const handleMouseLeave = () => {
    // Add a delay before closing the dropdown
    timeoutRef.current = setTimeout(() => {
      setActiveDropdown(null);
    }, 300); // 300ms delay
  };

  return (
    <div className="nav-links">
      <div
        className={`nav-link ${activeDropdown === "solutions" ? "active" : ""}`}
        onMouseEnter={() => handleMouseEnter("solutions")}
        onMouseLeave={handleMouseLeave}
      >
        <span className="nav-link__text">SOLUTIONS</span>
        <span className="dropdown-arrow">▼</span>

        <div
          className="simple-dropdown"
          onMouseEnter={() => handleMouseEnter("solutions")}
          onMouseLeave={handleMouseLeave}
        >
          <div className="simple-dropdown-content">
            <div className="simple-dropdown-grid">
              <Link to="/solutions/resonance" className="simple-dropdown-item">
                <div className="simple-dropdown-item-title">Exposure Management</div>
                <p className="simple-dropdown-item-description">
                  Our flagship exposure management platform that discovers, correlates, and prioritises external and
                  third-party risks.
                </p>
              </Link>
              <Link to="/solutions/autonomous-soc" className="simple-dropdown-item">
                <div className="simple-dropdown-item-title">SOC AI Agent</div>
                <p className="simple-dropdown-item-description">
                  Automates SOC operations with intelligent, self-learning AI agents.
                </p>
              </Link>
              <Link to="/solutions/intelligence-platform" className="simple-dropdown-item">
                <div className="simple-dropdown-item-title">Internet-wide Intel</div>
                <p className="simple-dropdown-item-description">
                  Delivers real-time insights from global internet-wide cyber security data.
                </p>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`nav-link ${activeDropdown === "industries" ? "active" : ""}`}
        onMouseEnter={() => handleMouseEnter("industries")}
        onMouseLeave={handleMouseLeave}
      >
        <span className="nav-link__text">INDUSTRIES</span>
        <span className="dropdown-arrow">▼</span>

        <div
          className="simple-dropdown"
          onMouseEnter={() => handleMouseEnter("industries")}
          onMouseLeave={handleMouseLeave}
        >
          <div className="simple-dropdown-content">
            <div className="simple-dropdown-grid">
              <Link to="/industries/government" className="simple-dropdown-item">
                <div className="simple-dropdown-item-title">Government</div>
                <p className="simple-dropdown-item-description">
                  Safeguarding national digital infrastructures with continuous, autonomous threat detection.
                </p>
              </Link>
              <Link to="/industries/telecommunications" className="simple-dropdown-item">
                <div className="simple-dropdown-item-title">Telecommunications</div>
                <p className="simple-dropdown-item-description">
                  Empowering telecom providers to secure expansive digital ecosystems against evolving cyber threats.
                </p>
              </Link>
              <Link to="/industries/energy" className="simple-dropdown-item">
                <div className="simple-dropdown-item-title">Energy & Utilities</div>
                <p className="simple-dropdown-item-description">
                  Protecting critical energy infrastructures through proactive external exposure management.
                </p>
              </Link>
              <Link to="/industries/financial" className="simple-dropdown-item">
                <div className="simple-dropdown-item-title">Financial Services</div>
                <p className="simple-dropdown-item-description">
                  Ensuring financial institutions maintain trust by mitigating cyber risks across digital assets.
                </p>
              </Link>
              <Link to="/industries/healthcare" className="simple-dropdown-item">
                <div className="simple-dropdown-item-title">Healthcare</div>
                <p className="simple-dropdown-item-description">
                  Securing sensitive health data with comprehensive attack surface visibility and threat detection.
                </p>
              </Link>
              <Link to="/industries/retail" className="simple-dropdown-item">
                <div className="simple-dropdown-item-title">Retail</div>
                <p className="simple-dropdown-item-description">
                  Defending online retail platforms from cyber threats to ensure seamless customer experiences.
                </p>
              </Link>
              <Link to="/industries/it" className="simple-dropdown-item">
                <div className="simple-dropdown-item-title">IT & Services</div>
                <p className="simple-dropdown-item-description">
                  Providing IT enterprises with tools to monitor and protect their digital environments effectively.
                </p>
              </Link>
              <Link to="/industries/manufacturing" className="simple-dropdown-item">
                <div className="simple-dropdown-item-title">Manufacturing</div>
                <p className="simple-dropdown-item-description">
                  Shielding manufacturing operations from cyber disruptions through continuous security assessments.
                </p>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Link to="/about" className="nav-link">
        <span className="nav-link__text">COMPANY</span>
      </Link>
    </div>
  );
};

export default SimpleNavigation;
